import React, { Component } from 'react';
import Profile from './components/Profile';
import './App.css';

class App extends Component {
  render() {
    return (
      <div className="app">
        <Profile />
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js